import { createSlice } from '@reduxjs/toolkit'

export const socialSlice = createSlice({
  name: 'social',
  initialState: {
    headline: 'Follow me on Social Media',
    medias: [
      { key: 'facebook', title: 'Facebook', url: 'https://www.facebook.com/teknikforce/' },
      { key: 'instagram', title: 'Instagram', url: 'https://www.instagram.com/teknikforceofficial/?hl=en' },
      { key: 'x', title: 'X', url: 'https://x.com/teknikforce' },
      { key: 'linkedin', title: 'LinkedIn', url: 'https://www.linkedin.com/company/teknikforce/' },
    ],
    titleColor: '#000000',
    cardBackgroundColor: '#ffffff',
    headlineColor: '#000000',
  },
  reducers: {
    setSocialField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setSocialMedias(state, action) {
      switch (action.payload.method) {
        case 'add':
          state.medias.push(action.payload.link)
          return
        case 'remove':
          state.medias.splice(action.payload.id, 1)
          return
        default:
          for (let i = 0; i < state.medias.length; i++) {
            if (state.medias[i].key === action.payload.name) {
              state.medias[i] = { ...state.medias[i], url: action.payload.url }
            }
          }
          return
      }
    },
    initializeSocial(state, action) {
      state.headline = 'Follow me on Social Media'
      state.medias = [
        { key: 'facebook', title: 'Facebook', url: 'https://www.facebook.com/teknikforce/' },
        { key: 'instagram', title: 'Instagram', url: 'https://www.instagram.com/teknikforceofficial/?hl=en' },
        { key: 'x', title: 'X', url: 'https://x.com/teknikforce' },
        { key: 'linkedin', title: 'LinkedIn', url: 'https://www.linkedin.com/company/teknikforce/' },

      ]
    }
  }
})

export const {
  setSocialField,
  setSocialMedias,
  initializeSocial
} = socialSlice.actions
export default socialSlice.reducer